module.exports = {
      id: "clipboard-usage",
      viewBox: "0 0 44 44",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#clipboard",
      toString: function () {
        return this.url;
      }
    }